<app-ion-common-header
  [id]="headerId"
  (backHeader)="backPage()"
  (focusHeader)="shownContent()"
  [title]="titlePage"
  [start]="startStage"
  [end]="endStage"
></app-ion-common-header>

<ion-content
  [attr.aria-hidden]="ariaHidden"
  [style.visibility]="ariaHidden ? 'hidden' : 'visible'"
>
  <div class="w-title">
    <app-ion-common-label
      [id]="idLabelPatrimonyIncome"
      class="document-type-label1 w-title"
      labelStyle="display-rg"
      labelDescription="Qual é o seu patrimônio total?"
      label="Considere aqui a soma aproximada dos seus bens financeiros e não financeiros.
      (saldo nas suas contas, investimentos, imóveis, veículos, entre outros)."
    >
    </app-ion-common-label>
  </div>

  <div class="conent-center">
    <form ngForm (ngSubmit)="submitForm($event)">
      <app-ion-common-input-currency
        [id]="  idInputCurrencyIncomePatrimony"
        [label]="'patrimônio'"
        [placeholder]="placeholder"
        [inputTextValue]="inputTextValue"
        (sendValueInput)="setInputTextValue($event)"
        [disabled]="!this.edit"
      >
      </app-ion-common-input-currency>
    </form>
  </div>
  <app-ion-common-button
    [id]=" idButtonIncomePatrimony"
    class="hidden"
    [ngClass]="{'hidden': !verifyStatusBtn()}"
    [attr.aria-hidden]="!verifyStatusBtn()"
    label="Continuar"
    (clickButton)="clickNext();"
  ></app-ion-common-button>
</ion-content>
